import React from 'react';
import './select-intent.scss';
import { SVGS } from '../../assets';
import { Avatar } from '../avatar';
export const SelectIntent = () => {
  return (
    <div className="select-intent-container">
      <div className="select-intent-container-item">
        <div className="select-intent-container-item-left">
          <img src={SVGS.RadioChecked} alt="" />
        </div>
        <Avatar
          icon={<img src={SVGS.PaymentGreen} alt="" />}
          iconBgColor={'#CDE5DB'}
        />
        <div className="select-intent-container-item-right">
          <div className="select-intent-container-item-right-top font-semibold">
            Payment
          </div>
          <div className="select-intent-container-item-right-bottom font-regular">
            Payment-related messages or updates about pending or completed
            payments
          </div>
        </div>
      </div>
      <div className="select-intent-container-item">
        <div className="select-intent-container-item-left">
          <img src={SVGS.RadioChecked} alt="" />
        </div>
        <Avatar
          icon={<img src={SVGS.CartBlue} alt="" />}
          iconBgColor={'#C4DCFF'}
        />
        <div className="select-intent-container-item-right">
          <div className="select-intent-container-item-right-top font-semibold">
            Order
          </div>
          <div className="select-intent-container-item-right-bottom font-regular">
            Order-related messages such as order creation, confirmation, or
            updates.
          </div>
        </div>
      </div>
    </div>
  );
};
